import { render, staticRenderFns } from "./GroupName.vue?vue&type=template&id=6c8bbf09&lang=pug"
import script from "./GroupName.vue?vue&type=script&lang=js"
export * from "./GroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports